"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  WIN: {
    id: "textBadge.text.win",
    defaultMessage: "Win",
    description: ""
  },
  LOSE: {
    id: "textBadge.text.lose",
    defaultMessage: "Lose",
    description: ""
  },
  START: {
    id: "textBadge.text.start",
    defaultMessage: "Start!",
    description: ""
  },
  FAILED: {
    id: "textBadge.text.failed",
    defaultMessage: "Failed!",
    description: ""
  },
  VICTORY: {
    id: "textBadge.text.victory",
    defaultMessage: "Victory",
    description: ""
  },
  STAGE_N_START: {
    id: "textBadge.text.stageNStart",
    defaultMessage: "Stage {n} Start",
    description: ""
  },
  LAST_STAGE_START: {
    id: "textBadge.text.lastStageStart",
    defaultMessage: "Last Stage Start",
    description: ""
  },
  STAGE_N_SUCCESS: {
    id: "textBadge.text.stageNSuccess",
    defaultMessage: "Stage {n} Success!!",
    description: ""
  },
  LAST_STAGE_SUCCESS: {
    id: "textBadge.text.lastStageSuccess",
    defaultMessage: "Last Stage Success!!",
    description: ""
  },
  STAGE_N_FAIL: {
    id: "textBadge.text.stageNFail",
    defaultMessage: "Stage {n} Fail",
    description: ""
  },
  LAST_STAGE_FAIL: {
    id: "textBadge.text.lastStageFail",
    defaultMessage: "Last Stage Fail",
    description: ""
  }
});

exports.default = _default;